<template>
    <div id="power-data" class="row-center" v-if="reFresh">
        <template v-if="$route.params.name == 'CapacitanceCompensation'">
            <CapacitanceCompensation />
        </template>
        <template v-else>
            <div class="left column-center">
                <area-details v-if="allArea[details]" width="180" :details="allArea[details]"
                    @click.native.stop="listShow = !listShow"></area-details>
                <div class="list">
                    <div class="search">
                        <input type="text" v-model="filterText" placeholder="请输入关键字" />
                        <img src="../../assets/img/search.png" alt="" />
                    </div>
                    <div class="tree" id="index-tree"  :style="routeName=='Inverter'||routeName=='Battery' ? 'height:65vh' : ''">
                        <el-scrollbar style="height:100%">
                            <el-tree check-strictly v-if="routeName === 'CircuitBreakerAging'"
                                :render-content="renderContent" check-on-click-node :expand-on-click-node="false"
                                default-expand-all @check="currentChange" :show-checkbox="showCheckBox" node-key="id"
                                @node-click="nodeClick" ref="tree" :data="treeData" :filter-node-method="filterNode" :default-checked-keys="defaultchecked">
                            </el-tree>
                            <el-tree :expand-on-click-node="false" check-strictly v-else-if="routeName === 'PowerData'"
                                check-on-click-node default-expand-all @check="currentChange"
                                :show-checkbox="showCheckBox" node-key="id" @node-click="nodeClick" ref="tree"
                                :data="treeData" :filter-node-method="filterNode" :default-checked-keys="defaultchecked">
                                <span  slot-scope="{ node, data }" class="power-data-item"
                                    :title="data.label.replace(/[^\x00-\xff]/g, 'AA').length>26?data.label:''">
                                    <div slot="reference">
                                        <span :class="[
                                            'power-data-item-label',
                                            { checked: data.loopId === currentLoop.loopId },
                                        ]" style="width:220rem">{{ node.label }}
                                        </span>
                                        <span class="power-data-item1" v-if="getLoopStatus(data) == undefined"
                                            style="color: #666; margin-right: 10rem">--</span>
                                        <span v-else-if="getLoopStatus(data) == 0 || getLoopStatus(data) == 'False'"
                                            class="power-data-item-open">分闸</span>
                                        <span v-else class="power-data-item-close">合闸</span>
                                    </div>
                                </span>
                            </el-tree>
                            <el-tree :expand-on-click-node="false" check-strictly v-else check-on-click-node
                                default-expand-all @check="currentChange" :show-checkbox="showCheckBox" node-key="loopId"
                                @node-click="nodeClick" ref="tree" :data="treeData" :filter-node-method="filterNode" :default-checked-keys="defaultchecked">
                                <span slot-scope="{ node, data }" class="power-data-item"
                                    :title="data.label.replace(/[^\x00-\xff]/g, 'AA').length>22?data.label:''">
                                    <span :class="[
                    'power-data-item-label',
                    { checked: data.loopId === currentLoop.loopId },
                  ]">
                                        <span slot="reference"> {{ node.label }}</span>
                                    </span>
                                </span>
                            </el-tree>
                        </el-scrollbar>
                    </div>
                </div>
                <div class="clearsel" v-if="(routeName=='Inverter'&&tag=='energy')||(routeName=='Battery'&&tag=='Issue')" @click="resetChecked()">清空选择</div>
            </div>
            <div class="data">
                <!-- 黎威更改断路器监测，把没有数据的页面显示出来 -->
                <div v-if="treeData.length === 0" class="no-found-data-warpper">
                    <img :src="require('../../assets/img/not_found_data.png')" alt="" />
                </div>
                <!-- v-if="currentLoop" -->
                <component v-else-if="currentLoop" :selectedLoops="checkedLoops" :currentLoop="currentLoop"
                    :is="componentName" />
                <div @click.stop="" class="area-list column-center" style="justify-content: flex-start"
                    v-show="listShow">
                    <div class="search row-center">
                        <input type="text" placeholder="请输入关键词" v-model="areaFilterText" />
                        <img src="../../assets/img/search.png" alt="" />
                    </div>
                    <div class="areas">
                        <template v-if="showAreaNumber === 0">
                            <span style="color: #8c939d; font-size: 18rem">暂无数据</span>
                        </template>
                        <template v-else v-for="(item, index) in allAreaList">
                            <div class="row row-center" style="justify-content: space-between; cursor: pointer"
                                :key="index" v-if="areaFilter(item)"
                                @click.stop="checkArea(index), (listShow = false)">
                                <img :src="item.areaImg" alt="" />
                                <p>{{ item.areaName }}</p>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
    import AreaDetails from "../../components/home/AreaDetails";
    import PowerData from "./PowerData";
    import MonitorData from "./MonitorData";
    import CircuitBreakerAging from "./CircuitBreakerAging";
    import CapacitanceCompensation from "./CapacitanceCompensation";
    import {
        GET_AREAS,
        GET_AREA_LOOPS,
        transformerList,
        breakerList,
        Arcprotection,
        harmonicAnalysis,
        InverterArea
    } from "../../api/power";

    import {
        subscribe,
        unsubscribe,
        subscribeByNodes
    } from "../../mqtt/index";
    import {
        subscribe as alarmSubscribe,
        unsubscribe as alarmUnsubscribe,
    } from "../../mqtt/alarm";
    export default {
        name: "PowerDataHome",
        components: {
            AreaDetails,
            PowerData,
            CircuitBreakerAging,
            CapacitanceCompensation,
            MonitorData
        },
        data() {
            return {
                selectedNodes: [],
                showAreaNumber: 0,
                reFresh: true,
                checkedLoops: [],
                currentLoop: null,
                filterText: "",
                listShow: false,
                details: -1,
                areaFilterText: "",
                allArea: [],
                loops: [],
                transformerList: [],
                breakerList: [],
                protect: [],
                Power: [],
                allAreaList:[],
                defaultchecked:null,
                InverterList:[] //逆变器
            };
        },
        computed: {

            tag() {
                return this.$route.params.tag;
            },
            routeName() {
                return this.$route.params.name;
            },
            showCheckBox() {
                return !(
                    this.tag === "Range" ||
                    this.routeName === "PowerData" ||
                    this.routeName === "Transformer" ||
                    this.routeName === "Breaker" ||
                    this.routeName === "PowerQuality" ||
                    this.routeName === "protect1" ||
                    (this.routeName === "Inverter"&&this.tag=='none') ||
                    this.routeName === "EnergyStorage" ||
                    (this.routeName === "Battery"&& this.tag=="none")
                );
            },
            componentName() {
                switch (this.$route.params.name) {
                    case "PowerData":
                    case "Extremum":
                    case "Running":
                    case "Transformer":
                    case "Breaker":
                    case "PowerTime":
                    case "CircuitBreakerAging":
                    case "PowerQuality":
                    case "protect1":
                    case "SubInverter":
                        return "PowerData";
                    case "Inverter":
                    case "EnergyStorage":
                    case "Battery":
                    case "BatteryGroup":
                        return "MonitorData"
                }
            },
            master() {
                if (!this.allArea[this.details]) {
                    return;
                }
                let areaId = this.allArea[this.details].areaId;
                let master = this.loops.filter((e) => e.masterAreaId === areaId);

                return master[0];
            },
            powerDataTree() {
                if (!this.allArea[this.details] || this.loops.length === 0) {
                    return [];
                }
                let areaId = this.allArea[this.details].areaId;

                this.loops = this.loops.filter(
                    (l) => l.loopName.indexOf("电容补偿") === -1
                );
                let master = this.loops.filter((loop) => loop.loopType === "IN");
                if (!master) {
                    return this.loops.map((item, index) => {
                        item.label = item.loopName;
                        item.id = index;
                    });
                }
                // 存在进线
                let loopMap = {};
                // 将master的loopId作为key, 放入loopMap, value初始为[];
                master.forEach((item) => (loopMap[item.loopId] = []));
                // 遍历loops, 将所有OUT回路以pid(父级回路id)放入loopMap中的对应数组中
                this.loops.forEach((loop, index) => {
                    loop.label = loop.loopName;
                    loop.id = index;
                    if (loop.loopType === "OUT") {
                        if (this.routeName == "Extremum" || this.routeName == "Running") {
                            //报表管理不加电容补偿

                            if (loop.loopName.indexOf("电容补偿") == -1) {
                                if (loopMap[loop.pid]) {
                                    loopMap[loop.pid].push(loop);
                                }
                            }
                        } else {
                            if (loopMap[loop.pid]) {
                                loopMap[loop.pid].push(loop)
                            }
                        }

                    }
                });
                master.forEach((item) => {
                    item.children = loopMap[item.loopId];
                });
                return master;
            },
            treeData() {
                switch (this.$route.params.name) {
                    case "Inverter":
                        if(this.InverterList.length>0){
                            let list = this.InverterList.filter(e=> e.label=e.loopName)
                            this.defaultchecked = [list[0].loopId];
                            this.checkedLoops = [list[0]]
                            this.currentLoop = list[0];
                            return list
                        }else{
                            return []
                        }
                        break
                    case "EnergyStorage":    
                        let list1 = [{children: [],label: "储能变流器1",loopId:1,"loopName": "储能变流器1",}]
                        this.currentLoop = list1[0];
                        return list1
                        break
                    case "Battery":
                        let obj = []
                        for (let index = 1; index <= 224; index++) {
                            obj.push({label: "电池组"+index,loopName: "电池组"+index,loopId:index,id:index,status:"group"})
                        }
                        let battery = [{children: obj,label: "电池堆",loopId:0,id:0,loopName:"电池堆"}]
                        this.defaultchecked = [0]
                        this.currentLoop = battery[0]
                        this.checkedLoops = battery.filter(e=> e.id==0)
                        return battery
                        break
                    case "PowerData":
                    case "Extremum":
                    case "SubInverter":
                    case "Running":
                        if(this.master){
                            this.defaultchecked = [this.master.loopId]
                            this.currentLoop = this.master;
                            this.checkedLoops = [this.master]
                        }
                        return this.powerDataTree;
                        break
                    case "Transformer":
                            let transformers = this.transformerList.map((d) => {
                                d.label = d.deviceName;
                                return d;
                            });
                            this.currentLoop = transformers[0];
                            return transformers;
                            break
                        case "Breaker":
                            let breaker = this.breakerList.map((d) => {
                                d.label = d.loopName;
                                return d;
                            });
                            this.currentLoop = breaker[0];
                            return this.breakerList;
                            break
                        case "CircuitBreakerAging":
                            let breakers = [];
                            this.currentLoop = breakers[0];
                            return this.breakerList;
                            break
                        case "protect1":

                            var proJack = this.protect.map((d) => {
                                d.label = d.loopName;
                                return d;
                            });
                            this.$store.commit("ArcprotectStatus", proJack[0]);
                            this.currentLoop = proJack[0];
                            return this.protect;
                            break
                        case "PowerQuality":
                            var Pro = this.Power.filter((d) => {
                                if (d.harmonic == 1) {
                                    d.label = d.loopName;
                                    return d;
                                }
                            });
                            this.$store.commit("ArcprotectStatus", Pro[0]);
                            this.currentLoop = Pro[0];
                            return Pro;
                            break
                }
            },
            //判断项目3合分闸
            getLoopStatus(tpl) {
                //修改回路mqtt实时接收
                return function (value) {
                    subscribe([value.subLoopUrl]);
                    alarmSubscribe([value]);
                    return this.$store.getters.mqttVal(value.subLoopUrl + "/SwitchOn");
                };
            },
            //项目4弧光保护
            getLoopStatus1(tpl) {
                //修改回路mqtt实时接收
                return function (value) {
                    subscribe([value.subLoopUrl])
                    return this.$store.getters.mqttVal(
                        value.subLoopUrl + "/total_status"
                    );
                };
            },
            //判断项目4合分闸
            getLoopLTStatus(tpl) {
                //修改回路mqtt实时接收
                return function (value) {
                    if (value.switchStatus) {
                        subscribe([value.switchStatus]);
                        return this.$store.getters.mqttVal(value.switchStatus);
                    } else {
                        value.switchStatus = "";
                        subscribe([value.switchStatus]);
                        return this.$store.getters.mqttVal(value.switchStatus);
                    }
                };
            },
        },
        mounted() {
            GET_AREAS().then((res) => {
                this.allArea = res.data.data.areas;
                if((this.routeName === "Inverter"&&this.tag==="none")||(this.routeName === "Inverter"&&this.tag==="energy")){
                    this.allAreaList = res.data.data.areas.filter(e=>e.areaId==25);
                    this.details = 1;
                }else if((this.routeName === "EnergyStorage"&&this.tag==="none")||(this.routeName === "Battery"&&this.tag==="none")){
                    this.allAreaList = res.data.data.areas.filter(e=>e.areaId==27);
                    this.details = 2;
                }else{
                    this.allAreaList = res.data.data.areas;
                    this.details = 0;
                }
                this.showAreaNumber = res.data.data.areas.length;
                this.getBreakerList(this.details);
                this.getProtect(this.details);
                this.getPower();
                this.getTransformerList(this.details);
                this.getInverterArea(this.details);
            });
            document.onclick = () => {
                this.listShow = false;
            };
            subscribeByNodes(["SwitchOn"]);
            subscribeByNodes(["Switch_on_MT"]); //分合状态
            // subscribe(["T1/KC_Mic1"]);
            this.loopInit();
        },
        methods: {
            //逆变器
            async getInverterArea(aid){
                let areaId = this.allArea[aid].areaId
                let response = await InverterArea(areaId);
                this.InverterList = response.data.data.loops || [];
            },
            checkArea(index){
                if((this.routeName === "Inverter"&&this.tag==="none")||(this.routeName === "Inverter"&&this.tag==="energy")){
                    this.details = 1;
                }else if((this.routeName === "EnergyStorage"&&this.tag==="none")||(this.routeName === "Battery"&&this.tag==="none")){
                    this.details = 2;
                }else{
                    this.details = 0;
                }
            },
            resetChecked(){
                this.checkedLoops = []
                this.selectedNodes = []
                this.$refs.tree.setCheckedKeys([]);
            },
            mouseenter(data) {
                this.$set(data, "show", true);
            },
            mouseleave(data) {
                this.$set(data, "show", false);
            },
            loopInit() {
                //let first = this.treeData[0];
                //this.$refs.tree.setCheckedNodes([first])
                //this.$refs.tree.setChecked([first], true)
                //this.$refs.tree.setCheckedKeys([0], true)
                //this.checkedLoops = [first]
            },
            unique(arr) {
                return Array.from(new Set(arr));
            },
            // getLoopStatus(tpl) {
            //   return this.$store.getters.mqttVal(tpl.subLoopUrl + "/SwitchOn");
            // },
            async getBreakerList(aid) {
                if (aid < 0) {
                    return;
                }
                let response = await breakerList(this.allArea[aid].areaId);
                this.breakerList = response.data.data.list || [];
            },
            async getProtect(aid) {
                if (aid < 0) {
                    return;
                }
                let response = await Arcprotection(this.allArea[aid].areaId);
                this.protect = response.data.data.list || [];
            },
            async getPower(aid) {
                //谐波分析
                if (aid < 0) {
                    return;
                }
                let response = await harmonicAnalysis(
                    this.$store.state.project.currentProject.projectId
                );
                this.Power = response.data.data.deviceLoops || [];
            },
            async getTransformerList(aid) {
                if (aid < 0) {
                    return;
                }
                let response = await transformerList(this.allArea[aid].areaId);
                this.transformerList = response.data.data.list || [];
            },
            renderContent(createElement, {
                node,
                data,
                store
            }) {
                return createElement(
                    "div", {
                        class: {
                            "row-center": true,
                            custom: true,
                        },
                        style: {
                            justifyContent: "space-between",
                            width: "100%",
                            paddingRight: "30rem",
                        },
                    },
                    [
                        createElement("span", {
                            domProps: {
                                innerHTML: data.label,
                            },
                        }),
                        createElement("span", {
                            domProps: {
                                innerHTML: data.type,
                            },
                        }),
                    ]
                );
            },
            currentChange(data, node, n) {
                this.selectedNodes = node.checkedNodes;
                this.checkedLoops = this.selectedNodes.filter((l) => {
                    return l ? l.label.indexOf(this.filterText) !== -1 : false;
                });
            },
            //点击传参
            //侧边栏子回路点击之后传参
            nodeClick(data) {
                // if(this.routeName=='Battery'){
                //     this.$router.push('/power-data/Battery/none?group=0')
                //     if(data.status=='group'){
                //         this.$router.push('/power-data/Battery/none?group=1')
                //     }
                // }
                
                this.$store.commit("ArcprotectStatus", data);
                this.currentLoop = data;
            },
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },

            areaFilter(item) {
                if (!this.areaFilterText) {
                    return true;
                }
                return item.areaName.indexOf(this.areaFilterText) !== -1;
            },
            updateMqtt(n, o) {
                if (o && o.subLoopUrl) {
                    unsubscribe([o.subLoopUrl]);
                    alarmUnsubscribe([o]);
                }
                if (n && n.subLoopUrl) {
                    subscribe([n.subLoopUrl]);
                    alarmSubscribe([n]);
                }
            },
        },
        watch: {
            areaFilterText(n, o) {
                if (!n) {
                    this.showAreaNumber = this.allArea.length;
                } else {
                    this.showAreaNumber = this.allArea.filter((area) => {
                        return area.areaName.indexOf(n) !== -1;
                    }).length;
                }
            },
            tag(n, o) {
                this.checkedLoops = [];
                this.$refs.tree.setCheckedNodes([]);
            },
            routeName() {
                if(this.routeName === "Inverter"&&this.tag==="none"||this.routeName === "Inverter"&&this.tag==="energy"){
                    this.allAreaList = this.allArea.filter(e=>e.areaId==25);
                    this.details = 1;
                }else if((this.routeName === "EnergyStorage"&&this.tag==="none")||(this.routeName === "Battery"&&this.tag==="none")){
                    this.allAreaList = this.allArea.filter(e=>e.areaId==27);
                    this.details = 2;
                }else{
                    this.allAreaList = this.allArea;
                    this.details = 0;
                }
                this.reFresh = false;
                this.$nextTick(() => {
                    this.reFresh = true;
                });
                this.loopInit();
                this.selectedNodes = [];
                this.filterText = ""
            },
            master(n, o) {
                this.updateMqtt(n, o);
            },
            currentLoop(n, o) {
                this.updateMqtt(n, o);
            },
            details(n) {
                this.getTransformerList(n);
                this.getBreakerList(n);
                this.getProtect(n);
                this.getPower(n);
                this.getInverterArea(n)
                GET_AREA_LOOPS(this.allArea[n].areaId).then((res) => {
                    this.loops = res.data.data.loops.filter(
                        (item) => !~item.loopName.indexOf("变压器设备")
                    ); // 临时过滤虚拟回路的方案
                });
                this.filterText = "";
            },
            filterText(val) {
                this.$refs.tree.filter(val);
                this.checkedLoops = this.selectedNodes.filter((l) => {
                    return l.loopName.indexOf(val) !== -1;
                });
            },
        },
    };
</script>

<style scoped lang="less">
    .clearsel{
        height:45rem;
        line-height: 45rem;
        border-top: 1px solid rgba(0, 0, 0, 0.15);
        width: 100%;
        text-align: center;
        font-size: 18rem;
        cursor: pointer;
    }
    .area-list {
        position: absolute;
        left: 0;
        top: 0;
        .w(504);
        .h(520);
        background-color: #fff;
        box-shadow: 0 4rem 40px 0 rgba(0, 43, 102, 0.28);
        padding: 24rem 16rem;
        z-index: 999;

        .areas {
            margin-top: 24rem;
            // min-height: 200rem;
            .h(400);
            overflow: auto;
            .row {
                margin-bottom: 24rem;

                p {
                    font-size: 16rem;
                    color: #333333;
                    font-weight: 400;
                    .w(400);
                }

                img {
                    .w(48);
                    .h(48);
                    margin-right: 13rem;
                    margin-left: 8rem;
                }
            }
        }

        .search {
            .h(48);
            width: 100%;
            overflow: hidden;
            border-radius: 24rem;
            border: 1px solid rgba(0, 0, 0, 0.15);
            position: relative;

            input {
                width: 100%;
                height: 100%;
                padding: 0 20rem;
                font-size: 16rem;
                color: #000000;
                font-weight: 400;
                line-height: 48rem;
            }

            img {
                position: absolute;
                right: 16rem;
                top: 15rem;
                z-index: 99;
            }
        }
    }

    #power-data {
        justify-content: space-between;

        .h(968);

        >.data {
            position: relative;
            .w(1265);
            height: 100%;
        }

        .left {
            height: 100%;
            justify-content: flex-start !important;
            background-color: #fff;
            .w(325);

            .list {
                padding: 24rem 0rem 24rem 24rem;
                overflow: hidden;
                width: 100%;

                .search {
                    display: flex;
                    flex-flow: row nowrap;
                    justify-content: center;
                    align-items: center;
                }

                input {
                    border: none;
                    outline: none;
                    font-size: 18rem;
                    color: #666666;
                    .w(262);
                }

                .tree {
                    margin-top: 35rem;

                    height: 750 / 1080 * 100vh;
                    overflow: auto;

                    &::-webkit-scrollbar {
                        width: 0 !important;
                    }

                    /deep/ .el-scrollbar__wrap {
                        overflow-x: hidden;
                        height: calc(100% - 10px);
                    }

                    .el-tree {
                        padding-right: 24rem;
                    }
                }
            }
        }
    }

    .power-data-item {
        display: flex;
        justify-content: space-between;
        position: relative;
        width: 100%;

        .power-data-item1 {
            position: absolute;
            right: 0;
        }

        .power-data-item-label {
            font-size: 18rem;
            font-weight: 400;
            color: #666666;
            width: 80%;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            // white-space: nowrap;
        }

        .power-data-item-label.checked {
            font-weight: bold;
            color: #0d94ff;
        }

        .power-data-item-open {
            color: #68d86a;
            position: absolute;
            right: 0;
        }

        .power-data-item-close {
            position: absolute;
            right: 0;
            color: #fd4238;
        }
    }

    .no-found-data-warpper {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
    }

    //弹出框样式
    .area_popper {
        background-color: #3d4451 !important;
        border-radius: 6px !important;
        opacity: 0.9 !important;
        font-size: 12px !important;
        color: #ffffff !important;
        padding: 0 !important;
        transform: translateY(12px);
    }

    .showText {
        margin: 8px;
    }

    &::-webkit-scrollbar {
        width: 0 !important;
    }

    /deep/ .el-scrollbar__wrap {
        overflow-x: hidden;
        height: calc(100% - 10px);
    }

    .el-tree {
        padding-right: 33rem;
    }
</style>